export default __webpack_public_path__ + "static/media/IMG-20241210-WA0033.56359de3.jpg";